export const ChartOfAccountTypeEnum = Object.freeze({
  CASH_AND_BANK: "CASH_AND_BANK",
  ACCOUNTS_RECEIVABLE: "ACCOUNTS_RECEIVABLE",
  INVENTORY: "INVENTORY",
  OTHER_CURRENT_ASSETS: "OTHER_CURRENT_ASSETS",
  FIXED_ASSETS: "FIXED_ASSETS",
  ACCUMULATED_DEPRECIATION: "ACCUMULATED_DEPRECIATION",
  OTHER_ASSETS: "OTHER_ASSETS",
  ACCOUNTS_PAYABLE: "ACCOUNTS_PAYABLE",
  CURRENT_LIABILITIES: "CURRENT_LIABILITIES",
  LONG_TERM_LIABILITIES: "LONG_TERM_LIABILITIES",
  EQUITY: "EQUITY",
  REVENUE: "REVENUE",
  COST_OF_GOODS_SOLD: "COST_OF_GOODS_SOLD",
  EXPENSES: "EXPENSES",
  OTHER_EXPENSES: "OTHER_EXPENSES",
  OTHER_INCOME: "OTHER_INCOME",
});
